export const COLUMNS_HEADERS = [
  {id: 'name', key: 'name', label: 'Name'},
  {id: 'postId', key: 'postId', label: 'Post ID'},
  {id: 'label', key: 'label', label: 'Label'},
  {id: 'address', key: 'address', label: 'Country'},
];

export const RECORDS_PER_PAGE = 20;
